module.exports = __webpack_public_path__ + "img/dl4.19af18c4.png";